import { render, staticRenderFns } from "./colorselector.vue?vue&type=template&id=e937d256&scoped=true"
import script from "./colorselector.vue?vue&type=script&lang=js"
export * from "./colorselector.vue?vue&type=script&lang=js"
import style0 from "./colorselector.vue?vue&type=style&index=0&id=e937d256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e937d256",
  null
  
)

export default component.exports